import React from "react";
import {
	Grid,
	Button
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import {Link} from "react-router-dom";
import {getImage} from "../../../../../utils/image";
import clsx from "clsx";
import getNumberBitDepth from "../../../../../utils/numberFormat";
import {useSelector} from "react-redux";
import getTrans from "../../../../../languages/getTrans";

const formatAmount = (amount) => {
	const formattedAmount = getNumberBitDepth(
		amount,
		amount % 1 === 0 ? 0 : 2,
		'.',
		' '
	);
	return `$${formattedAmount}`;
};

const PaymentCard = ({ item }) => {
	const classes = useStyles();
	const { minPay, commission } = React.useMemo(() => {
		if (item?.minValue !== undefined || item?.commissionPercentage !== undefined || item?.commissionValue !== undefined) {
			const minValue = Number.parseFloat(item.minValue || 0);
			const commissionPercentage = Number.parseFloat(item.commissionPercentage || 0);
			const commissionValue = Number.parseFloat(item.commissionValue || 0);

			const formattedMinPay = formatAmount(minValue);

			let formattedCommission = '';
			if (commissionPercentage > 0 && commissionValue > 0) {
				const formattedCommissionValue = formatAmount(commissionValue);
				formattedCommission = `${commissionPercentage}% + ${formattedCommissionValue}`;
			} else if (commissionPercentage > 0) {
				formattedCommission = `${commissionPercentage}%`;
			} else if (commissionValue > 0) {
				formattedCommission = formatAmount(commissionValue);
			} else {
				formattedCommission = '0%';
			}

			return {
				minPay: formattedMinPay,
				commission: formattedCommission
			};
		}
		if (!item?.payInfo || !Array.isArray(item.payInfo) || item.payInfo.length === 0) {
			return {
				minPay: '$3',
				commission: '0%'
			};
		}

		const minValue = Math.min(...item.payInfo.map(p => Number.parseFloat(p.minValue || 0)));

		const firstPaymentMethod = item.payInfo[0];
		const commissionPercentage = Number.parseFloat(firstPaymentMethod.commissionPercentage || 0);
		const commissionValue = Number.parseFloat(firstPaymentMethod.commissionValue || 0);

		const formattedMinPay = formatAmount(minValue);

		let formattedCommission = '';
		if (commissionPercentage > 0 && commissionValue > 0) {
			const formattedCommissionValue = formatAmount(commissionValue);
			formattedCommission = `${commissionPercentage}% + ${formattedCommissionValue}`;
		} else if (commissionPercentage > 0) {
			formattedCommission = `${commissionPercentage}%`;
		} else if (commissionValue > 0) {
			formattedCommission = formatAmount(commissionValue);
		} else {
			formattedCommission = '0%';
		}

		return {
			minPay: formattedMinPay,
			commission: formattedCommission
		};
	}, [item]);
	const country = useSelector((state) => state?.payflow?.selectCountry);

	const itemId = item?.id || item?.paymentMethodId;
	const itemLabel = item?.label || item?.paymentMethodName || item?.name;
	const fullUrlCard = `/top-up-balance/${ country?.slug }/${ item.groupSlug }/${ itemId }`;

	return (
		<Button className={classes.card} component={Link} to={fullUrlCard}>
			<div className={classes.cardName}>{itemLabel}</div>
			<div className={clsx({
				[classes.cardLogo]: true,
				'--payssion': Boolean(item.is_payssion)
			})}>
				<img src={getImage(item.image_id, {height: 40})}/>
			</div>
			<Grid container spacing={3}>
				<Grid item>
					<div className={classes.cardInfo}>
						<div className={classes.cardInfoTitle}>{getTrans('paymentCard.Минимальный платёж')}</div>
						<div className={classes.cardInfoValue}>{minPay}</div>
					</div>
				</Grid>
				<Grid item>
					<div className={classes.cardInfo}>
						<div className={classes.cardInfoTitle}>{getTrans('paymentCard.Комиссия')}</div>
						<div className={classes.cardInfoValue}>{commission}</div>
					</div>
				</Grid>
			</Grid>
		</Button>
	)
}

const useStyles = makeStyles(() => ({
	card: {
		width: "100%",
		borderRadius: "8px",
		padding: "10px 14px",
		textAlign: "initial",
		boxSizing: "border-box",
		flexDirection: "column",
		alignItems: "flex-start",
		border: "1px solid #FFFFFF1A",
		background: "#FFFFFF0D!important",
	},
	cardName: {
		fontSize: 18,
		color: "white",
		fontWeight: "500",
		lineHeight: "22px",
	},
	cardLogo: {
		height: 40,
		display: "flex",
		marginTop: "10px",
		marginBottom: "12px",
		alignItems: "center",
		"& img": {
			height: "100%",
			objectFit: "cover",
		},
		"&.--payssion": {
			width: 40,
			overflow: "hidden",
			borderRadius: "100%",
			position: "relative",
		},
		"&:not(.--payssion) img": {
			transform: "scale(1.15)",
		}
	},

	cardInfo: {},
	cardInfoTitle: {
		fontSize: 12,
		color: "#767D88",
		lineHeight: "16px"
	},
	cardInfoValue: {
		fontSize: 16,
		color: "#E7E6E6",
		lineHeight: "20px"
	},
}));

export default PaymentCard
